import { render, staticRenderFns } from "./FormStepSuccess.vue?vue&type=template&id=137e71cb&scoped=true"
import script from "./FormStepSuccess.vue?vue&type=script&lang=js"
export * from "./FormStepSuccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137e71cb",
  null
  
)

export default component.exports